import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/hooks/useAuth";
import { getAccessToken } from "@privy-io/react-auth";

export const RECOMMENDED_USERS_QUERY_KEY = ["users", "recommended"] as const;

export interface RecommendedUser {
  id: string;
  username: string;
  name: string | null;
  image: string | null;
  bio: string | null;
  followers: number;
  post_count: number;
}

export function useRecommendedUsersQuery() {
  const { isLoggedIn, isReady, userId } = useAuth();

  return useQuery<RecommendedUser[]>({
    queryKey: RECOMMENDED_USERS_QUERY_KEY,
    queryFn: async () => {
      const headers: Record<string, string> = { "Content-Type": "application/json" };
      try {
        const token = await getAccessToken();
        if (token) headers["Authorization"] = `Bearer ${token}`;
      } catch {}
      const res = await fetch("/api/users/recommended", { headers });
      if (!res.ok) throw new Error(`${res.status}`);
      const data = await res.json();
      return (data.recommended || []).filter(
        (u: RecommendedUser) => u.id !== userId
      );
    },
    enabled: isReady && isLoggedIn,
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
  });
}
